import { Separator } from "@/components/ui/separator";
import { AuthShell } from "@/features/auth";
import { Route as LoginRoute } from "@/routes/login/check-email";
import { Route as SignUpRoute } from "@/routes/signup/check-email";
import { Link } from "@tanstack/react-router";

type CheckEmailPageProps = {
  newUser: boolean;
};

export function CheckEmailPage({ newUser }: CheckEmailPageProps) {
  let route;

  if (newUser) {
    route = SignUpRoute;
  } else {
    route = LoginRoute;
  }

  const { email, redirect } = route.useSearch();

  return (
    <AuthShell newUser={newUser}>
      <div className="space-y-6">
        <div>
          <h2 className="mb-2 text-2xl font-bold">Check your inbox</h2>
          <p className="text-muted-foreground text-sm">
            {newUser
              ? "We've just sent a unique sign-up link to your email:"
              : "We've just sent a unique sign-in link to your email:"}
            <br />
            <span className="text-foreground font-semibold">{email}</span>
          </p>
        </div>

        <Separator />

        <p className="text-muted-foreground text-sm leading-relaxed">
          The link is valid for a limited time. If you haven't received it, check your spam folder
          or{" "}
          <Link
            to={newUser ? "/signup" : "/login"}
            search={redirect ? { redirect } : {}}
            className="text-primary underline underline-offset-2"
          >
            send the link again
          </Link>
          .
        </p>
      </div>
    </AuthShell>
  );
}
